"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileAssetValue = exports.FileAssetValueDefaultProps = exports.VIEWER_DOCUMENT_TYPES = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_value_1 = require("./entity-value");
var coalesce_1 = require("../../utils/coalesce");
var use_modal_1 = require("../../hooks/use-modal");
var lodash_1 = require("lodash");
var link_1 = require("../elements/link");
var content_1 = require("../elements/content");
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var file_asset_viewer_1 = require("./file-asset-viewer");
var icon_1 = require("../elements/icon");
var arrow_down_circle_icon_1 = require("../icons/arrow-down-circle.icon");
exports.VIEWER_DOCUMENT_TYPES = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.ms-powerpoint", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/pdf"];
exports.FileAssetValueDefaultProps = {
  showDescription: true,
  variant: 'large'
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-items: center;\n    flex-direction: row;\n  "], ["\n    align-items: center;\n    flex-direction: row;\n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    \n    h4 {\n      font-size: 0.9em;\n      color: ", ";\n    }\n\n    &:hover {\n      .sh-entity-bubble-image {\n        border-color: ", ";\n      }\n    }\n  "], ["\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    \n    h4 {\n      font-size: 0.9em;\n      color: ", ";\n    }\n\n    &:hover {\n      .sh-entity-bubble-image {\n        border-color: ", ";\n      }\n    }\n  "])), theme_1.theme.COLOR('text-mid'), theme_1.theme.COLOR("pri  mary-lighter"))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    display: inline-block;\n\n    &:hover {\n      filter: brightness(1.05);\n    }\n  "], ["\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    display: inline-block;\n\n    &:hover {\n      filter: brightness(1.05);\n    }\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    min-height: 72px;\n    margin-top: ", ";\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    max-width: 800px;\n  "], ["\n    min-height: 72px;\n    margin-top: ", ";\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    max-width: 800px;\n  "])), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    margin-top: 2px;\n    margin-left: ", ";\n    padding-left: ", ";\n  "], ["\n    ", ";\n    margin-top: 2px;\n    margin-left: ", ";\n    padding-left: ", ";\n  "])), theme_1.theme.V_DOT_BG('line-mid', 1.5), theme_1.theme.UNIT(4), theme_1.theme.UNIT(6))
});
var ViewerLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    cursor: pointer;\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    display: inline-block;\n\n    &:hover {\n      filter: brightness(1.05);\n    }\n  "], ["\n    cursor: pointer;\n    flex-shrink: 0;\n    flex-wrap: nowrap;\n    display: inline-block;\n\n    &:hover {\n      filter: brightness(1.05);\n    }\n  "])))
});
var ViewerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DownloadButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-top: -3px;\n    align-self: center;\n  "], ["\n    margin-top: -3px;\n    align-self: center;\n  "])))
});
var DownloadButtonIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 30px;\n    height: 30px;\n\n    &:hover {\n      ", "\n    }\n  "], ["\n    width: 30px;\n    height: 30px;\n\n    &:hover {\n      ", "\n    }\n  "])), theme_1.theme.FILL('primary-lighter'))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin: 0;\n    font-size: 1em;\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n\n  "], ["\n    margin: 0;\n    font-size: 1em;\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n\n  "])))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    font-weight: 500;\n    margin-left: ", ";\n  "], ["\n    font-weight: 500;\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var MetaStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding-left: ", ";\n    font-weight: 400;\n    display: inline-block;\n    font-size: 0.8em;\n    text-transform: uppercase;\n  "], ["\n    padding-left: ", ";\n    font-weight: 400;\n    display: inline-block;\n    font-size: 0.8em;\n    text-transform: uppercase;\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Viewer: (0, styled_components_1.default)(file_asset_viewer_1.FileAssetViewer)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ViewerStyles),
  ViewerLink: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ViewerLinkStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Title: styled_components_1.default.h1(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Name: styled_components_1.default.span(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Meta: styled_components_1.default.span(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), MetaStyles),
  DownloadButton: styled_components_1.default.a(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), DownloadButtonStyles),
  DownloadButtonIcon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), DownloadButtonIconStyles),
  Description: (0, styled_components_1.default)(content_1.Content)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
var FileAssetValue = function (props) {
  var className = props.className,
    entity = props.entity,
    showDescription = props.showDescription,
    rest = __rest(props, ["className", "entity", "showDescription"]);
  var typeImage = (0, lodash_1.get)(entity, 'file.typeImage');
  var renderedFile = __assign(__assign({}, entity), {
    openGraph: __assign(__assign({}, entity.openGraph || {}), {
      image: typeImage || (0, lodash_1.get)(entity, 'openGraph.image')
    })
  });
  var description = (0, coalesce_1.coalesce)(entity, ['description.text', 'openGraph.description.plain', 'openGraph.description.text']);
  var hasDescription = showDescription && description;
  var labels = (0, lodash_1.filter)([(0, lodash_1.get)(entity, 'type.name'), (0, lodash_1.get)(entity, 'file.typeName')]);
  var imageStyle = !!typeImage ? 'logo' : 'bubble';
  var label = labels.length ? labels.join(' – ') : '{{FILE_ASSET}}';
  var file = entity.file;
  var modal = (0, use_modal_1.useModal)();
  var inner = react_1.default.createElement(My.Value, __assign({
    showMenu: true,
    imageSize: 68,
    showNameFirst: true,
    subtitle: entity.file && entity.file.formattedSize,
    imageStyle: imageStyle,
    useImageZoom: false,
    entity: renderedFile,
    label: label,
    className: className
  }, rest));
  var to = file && file.url;
  var type = file && file.type;
  var onClick = function () {
    modal.show(react_1.default.createElement(My.Viewer, {
      entity: entity
    }), {
      hideOnOverlayClick: true,
      opacity: 0.97,
      title: react_1.default.createElement(My.Title, null, react_1.default.createElement(My.DownloadButton, {
        title: "Download File",
        target: "_blank",
        href: file.url
      }, react_1.default.createElement(My.DownloadButtonIcon, {
        size: 30,
        color: "light"
      }, react_1.default.createElement(arrow_down_circle_icon_1.ArrowDownCircle, null))), react_1.default.createElement(My.Name, null, entity.name), react_1.default.createElement(My.Meta, null, file.typeName, " (", file.formattedSize, ")"))
    });
  };
  //<My.Link to={to}>{inner}</My.Link> :
  return react_1.default.createElement(My.Container, null, to ? (0, lodash_1.includes)(exports.VIEWER_DOCUMENT_TYPES, type) ? react_1.default.createElement(My.ViewerLink, {
    onClick: onClick
  }, inner) : react_1.default.createElement(My.Link, {
    target: "_blank",
    to: entity.file && entity.file.url || ''
  }, inner) : inner, hasDescription && react_1.default.createElement(My.Description, {
    title: description,
    tiny: true,
    className: "shp-file-asset-value__description"
  }, react_1.default.createElement(markdown_to_jsx_1.default, null, description)));
};
exports.FileAssetValue = FileAssetValue;
exports.FileAssetValue.defaultProps = exports.FileAssetValueDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;